import { planTypes } from '@/common/constants';
import { isFromZeConsumption } from './helper/utils';

export default {
  key: planTypes[planTypes.EVENT_SAAS],
  data() {
    return {
      logo: require('@/assets/plans/eventsaas.svg'),
      title: `${this.$t('billing.planform.title.zoom_events')}${isFromZeConsumption() ? ' ' + this.$t('billing.events.ppa.title') : ''}`,
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.EVENT_SAAS,
      description: this.$t('zoom events'),
      totalLimitDesc: "",
      configDescription: this.$t('billing.events.eventSaas.desc'),
    };
  },
};
